/* COLAGENO MARIBEL - comportamientos propios tras salir de Zipify Pages.
   Cubre lo que antes hacia fr-page-published-scripts.min.js en esta pagina:
   carrusel de producto con miniaturas, carruseles horizontales de imagenes,
   selector de cantidad y refresco de precios al cambiar de variante.
   El add to cart NO depende de este archivo: los buy-box son formularios
   nativos que postean a /cart/add aunque el JS no cargue. */
(function () {
  'use strict';

  var root = document.getElementById('mrb-col-root');
  if (!root) return;

  function all(sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  }

  /* ------------------------------------ carrusel de producto con miniaturas */
  function initProductCarousel(wrapper) {
    var track = wrapper.querySelector('[data-carousel]');
    if (!track) return;

    var slides = all('[data-img-carousel-wrapper]', track);
    if (!slides.length) return;

    var prev = wrapper.querySelector('[data-prev-img-btn]');
    var next = wrapper.querySelector('[data-next-img-btn]');
    var thumbs = all('[data-media-icon]', wrapper);
    var thumbPrev = wrapper.querySelector('[data-thumb-prev-btn]');
    var thumbNext = wrapper.querySelector('[data-thumb-next-btn]');
    var wrap = wrapper.querySelector('[data-thumbnails-wrapper]');
    var index = 0;
    var refrescarTiras = null;

    /* la tira de miniaturas puede ser vertical (thumbnails-left) u horizontal */
    function ejeVertical(el) {
      return el.scrollHeight - el.clientHeight > el.scrollWidth - el.clientWidth;
    }

    /* las diapositivas ocultas nunca disparan el lazy load, asi que la
       siguiente y la anterior se piden por adelantado */
    function precargar(i) {
      [i, i + 1, i - 1].forEach(function (n) {
        var s = slides[(n % slides.length + slides.length) % slides.length];
        var img = s && s.querySelector('img');
        if (img) img.loading = 'eager';
      });
    }

    function acercar(i) {
      if (!wrap || !thumbs[i]) return;
      var t = thumbs[i].getBoundingClientRect();
      var c = wrap.getBoundingClientRect();
      if (ejeVertical(wrap)) {
        if (t.top < c.top) wrap.scrollTop += t.top - c.top;
        else if (t.bottom > c.bottom) wrap.scrollTop += t.bottom - c.bottom;
      } else {
        if (t.left < c.left) wrap.scrollLeft += t.left - c.left;
        else if (t.right > c.right) wrap.scrollLeft += t.right - c.right;
      }
    }

    function show(i) {
      index = (i % slides.length + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.style.display = n === index ? '' : 'none';
      });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('active', n === index);
      });
      precargar(index);
      acercar(index);
      if (typeof refrescarTiras === 'function') refrescarTiras();
    }

    if (slides.length > 1) {
      if (prev) prev.classList.remove('hidden');
      if (next) next.classList.remove('hidden');
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
    });

    /* flechas de la tira de miniaturas, en el eje que corresponda */
    if (wrap && thumbPrev && thumbNext) {
      var paso = function () {
        return ejeVertical(wrap)
          ? Math.max(60, wrap.clientHeight * 0.6)
          : Math.max(60, wrap.clientWidth * 0.6);
      };
      /* la tira tiene overflow:hidden, donde scrollBy con behavior smooth
         no mueve nada en Chrome: se asigna la posicion directamente */
      var mover = function (signo) {
        if (ejeVertical(wrap)) wrap.scrollTop += signo * paso();
        else wrap.scrollLeft += signo * paso();
        refrescarTiras();
      };
      refrescarTiras = function () {
        var vert = ejeVertical(wrap);
        var pos = vert ? wrap.scrollTop : wrap.scrollLeft;
        var max = vert
          ? wrap.scrollHeight - wrap.clientHeight
          : wrap.scrollWidth - wrap.clientWidth;
        var sobra = max > 2;
        thumbPrev.classList.toggle('hidden', !sobra || pos <= 1);
        thumbNext.classList.toggle('hidden', !sobra || pos >= max - 1);
      };
      thumbPrev.addEventListener('click', function () { mover(-1); });
      thumbNext.addEventListener('click', function () { mover(1); });
      wrap.addEventListener('scroll', refrescarTiras);
      window.addEventListener('resize', refrescarTiras);
      refrescarTiras();
    }

    show(0);
  }

  /* ------------------------- carruseles horizontales (testimonios, imagenes) */
  function initScroller(carousel) {
    var pista = carousel.querySelector('[data-carousel-container]');
    if (!pista) return;

    var items = all('[data-carousel-item]', pista);
    if (items.length < 2) return;

    var izqWrap = carousel.querySelector('[data-prev-btn-wrapper]');
    var derWrap = carousel.querySelector('[data-next-btn-wrapper]');
    var izq = carousel.querySelector('[data-prev-btn]');
    var der = carousel.querySelector('[data-next-btn]');

    function paso() {
      var r = items[0].getBoundingClientRect();
      return r.width || pista.clientWidth * 0.5;
    }

    function refrescar() {
      var sobra = pista.scrollWidth - pista.clientWidth > 2;
      if (izqWrap) {
        izqWrap.classList.toggle('hidden', !sobra || pista.scrollLeft <= 1);
      }
      if (derWrap) {
        derWrap.classList.toggle(
          'hidden', !sobra || pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 1);
      }
    }

    /* asignacion directa: con scroll-snap el scrollBy suave se revierte */
    function mover(signo) {
      pista.scrollLeft += signo * paso();
      refrescar();
    }

    if (izq) izq.addEventListener('click', function () { mover(-1); });
    if (der) der.addEventListener('click', function () { mover(1); });
    pista.addEventListener('scroll', refrescar);
    window.addEventListener('resize', refrescar);
    refrescar();
  }

  /* ------------------------------------------------- selector de cantidad */
  function initQty(caja) {
    var input = caja.querySelector('[data-mrb-product-quantity]');
    if (!input) return;
    var menos = caja.querySelector('[data-mrb-product-decrease-qty]');
    var mas = caja.querySelector('[data-mrb-product-increase-qty]');

    function fijar(n) {
      if (isNaN(n) || n < 1) n = 1;
      if (n > 999) n = 999;
      input.value = n;
    }

    if (menos) {
      menos.addEventListener('click', function () {
        fijar(parseInt(input.value, 10) - 1);
      });
    }
    if (mas) {
      mas.addEventListener('click', function () {
        fijar(parseInt(input.value, 10) + 1);
      });
    }
    input.addEventListener('change', function () {
      fijar(parseInt(input.value, 10));
    });
  }

  /* --------------------- precios e imagen al cambiar de variante */
  function initVariantes(form) {
    var eid = form.getAttribute('data-mrb-eid');
    var fuente = document.querySelector(
      '.mrb-variant-data[data-mrb-eid="' + eid + '"]');
    if (!fuente) return;

    var datos;
    try {
      datos = JSON.parse(fuente.textContent || '[]');
    } catch (err) {
      return;
    }
    if (!datos.length) return;

    var radios = all('.mrb-variant-radio', form);
    if (!radios.length) return;

    var precio = form.querySelector('[data-mrb-product-discount-price]');
    var tachado = form.querySelector('[data-mrb-product-price]');
    var ahorro = form.querySelector('[data-mrb-product-discount-difference]');
    var unitario = form.querySelector('.zpa-el-price-unit');
    var envCmp = form.querySelector('[data-mrb-product-price-wrapper]');
    var envAhorro = form.querySelector('[data-mrb-product-discount-difference-wrapper]');
    var envUnit = form.querySelector('[data-mrb-product-unit-price-wrapper]');
    var imagen = form.querySelector('[data-mrb-variant-image]');
    var boton = form.querySelector('[data-mrb-atc]');
    var rotulo = form.querySelector('[data-mrb-atc-text]');
    var rotuloOriginal = rotulo ? rotulo.textContent : '';

    function aplicar(id) {
      var v = null;
      for (var i = 0; i < datos.length; i++) {
        if (String(datos[i].id) === String(id)) { v = datos[i]; break; }
      }
      if (!v) return;

      if (precio) precio.textContent = v.price;
      if (tachado) tachado.textContent = v.compare;
      if (ahorro) ahorro.textContent = v.saved;
      if (envCmp) envCmp.classList.toggle('hidden', !v.has_compare);
      if (envAhorro) envAhorro.classList.toggle('hidden', !v.has_compare);
      if (envUnit) envUnit.classList.toggle('hidden', !v.unit);
      if (unitario && v.unit) unitario.textContent = v.unit;
      if (imagen && v.image) imagen.setAttribute('src', v.image);
      if (boton) {
        boton.disabled = !v.available;
        var agotado = root.getAttribute('data-mrb-soldout') || 'AGOTADO';
        if (rotulo) rotulo.textContent = v.available ? rotuloOriginal : agotado;
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (r.checked) aplicar(r.value);
      });
      if (r.checked) aplicar(r.value);
    });
  }

  function iniciar() {
    all('.zpa-el-product-carousel').forEach(initProductCarousel);
    all('.zpa-mc-carousel').forEach(initScroller);
    all('[data-mrb-quantity-el]').forEach(initQty);
    all('.mrb-atc-form').forEach(initVariantes);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
